import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class SearchFilterService {

  constructor() { }

  filter(flux, filterValue) {
    const actuFilter = [];

    flux.forEach((el, index) => {
      const keyword = filterValue.toLowerCase();
      const title = el.title.toLowerCase();
      const description = el.description.toLowerCase();
      let tag;
      el.categories.length < 1 ? tag = '' : tag = el.categories[0].name.toLowerCase();

      // if (title.indexOf(keyword) !== -1 || description.indexOf(keyword) !== -1) {
      if (title.indexOf(keyword) !== -1 || description.indexOf(keyword) !== -1 || tag.indexOf(keyword) !== -1) {
        actuFilter.push(el);
      }
    });

    return actuFilter;

  }
}
